$(document).ready(function () {
  function updateCustomTotal() {
    let total = 0;

    $('.cart-item__details').each(function () {
      // Search upwards and downwards for the element with data-cart-quantity
      const quantityEl = $(this).closest('.cart-item').find('[data-cart-quantity]');
      const quantity = parseInt(quantityEl.attr('data-cart-quantity')) || 0;

      // console.log('Cart Item Quantity:', quantity);

      $(this).find('.product-option dd').each(function () {
        const text = $(this).text().trim();
        const num = parseFloat(text.replace(/[^\d.]/g, '')); // removes units like "mg"

        // console.log('Found dd value:', text, 'Parsed:', num);

        if (!isNaN(num)) {
          total += num * quantity;
        }
      });
    });

    // console.log('Final total:', total);
    $('.custom-cart-text .custom-total').text(total);
  }

  setInterval(updateCustomTotal, 1000);
});
